import { searchConstants } from './constants';

var viewActions = require ('../../store/view.actions');

var searchService = require ('./api');


export const searchActions = {
    doSearch, receiveSearchResults, startSearch , getCourses,
    doFullSearch
};




function getCourses( token, calendarID ) {
  return dispatch => {
      searchService.getCourses( token, calendarID )
          .then( json => {
              dispatch({
                type: searchConstants.LOAD_COURSES,
                courses: json
              })
           } )

  }
}


function doFullSearch( token, calendarID, qryString ) {
  return dispatch => {
    dispatch(viewActions.isLoadingModule('isSearching',true));
    dispatch(startSearch( qryString)) ;

    searchService.searchPersona ( token, calendarID, qryString ) 
      .then( json => {
          dispatch(receiveSearchResults( qryString, json))
          dispatch(viewActions.isLoadingModule('isSearching',false)  )
      })
  }
}
function doSearch( token, calendarID, qryString ) {
    return dispatch => {
      dispatch(viewActions.isLoadingModule('isSearching',true));
      dispatch(startSearch( qryString)) ;

      searchService.searchStudents ( token, calendarID, qryString )
        .then( json => {
            dispatch(receiveSearchResults( qryString, json))
            dispatch(viewActions.isLoadingModule('isSearching',false)  )
        })
    }
  }

function startSearch(qryString) {
    return {
        type: searchConstants.START_SEARCH,
        searchQry: qryString,
        searchResults:  []
    }
}

function receiveSearchResults(qryString, json) {
    return {
      type: searchConstants.RECEIVE_SEARCH_RESULTS,
      searchQry: qryString,
      searchResults: json
    }
  }
